import React, { useContext } from "react";
import { DeviceContext, deviceType } from '@providers';

import DesktopCollectionPage from "@src/pages/ProductList/Collection/DesktopCollectionPage";
import MobileCollectionPage from "@src/pages/ProductList/Collection/MobileCollectionPage";

const CollectionPage = ({ match }) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    isMobile ?
      <MobileCollectionPage match={match} /> : <DesktopCollectionPage match={match} />
  )
};

export default CollectionPage;
